<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>design_services</md-icon>
          </div>
          <h4 class="title">
            Client Information
          </h4>
        </md-card-header> -->
        <input v-model="client.id" :readonly="true" type="hidden"/>
        <md-card-content>
          <md-button class="md-icon-text md-round md-primary" v-on:click="findClient(client.client_phone)">Find Client</md-button>
          <div class="md-layout" style="margin-top:10px;">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Name</span>
            </label> -->
            <div class="md-layout-item md-small-size-100">
              <div class="md-layout-item">
                <validation-provider rules="clientname" ref="client_name" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label for="">Client Name</label>
                  <md-input v-model="client.client_name" :readonly="shouldDisable" required/>
                  <validation-error :errors="apiValidationErrors.client_name" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
            </div>
          </div>
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Phone</span>
            </label> -->
          <div class="md-layout">
            <div class="md-layout-item md-small-size 100">
              <div class="md-layout-item">
                <validation-provider rules="phone" ref="client_phone" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label for="">Phone</label>
                  <md-input v-model="client.client_phone" @change="changePhone" readonly required/>
                  <validation-error :errors="apiValidationErrors.client_phone" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
                </validation-provider>
              </div>
            </div>
          </div>
            <!-- </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-form-label">
                <span style="color:brown">Email</span>
              </label> -->
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100">
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <label for="">Email</label>
                  <md-input v-model="client.client_email" type="email" :readonly="shouldDisable" />
                  <validation-error :errors="apiValidationErrors.client_email" />
                </md-field>
              </div>
            </div>
          </div>
          <div class="md-layout">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Address</span>
            </label> -->
            <div class="md-layout-item md-small-size-100">
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <label for="">Address</label>
                  <md-input v-model="client.client_address" :readonly="shouldDisable"/>
                  <validation-error :errors="apiValidationErrors.client_address" />
                </md-field>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>  
    </div>
    <modal ref="modalList" class="coba">
      <template v-slot:header>
        <div>
          <h3>List Client</h3>
        </div>
        <md-button class="md-dense md-round md-icon-button" @click="CloseListClient()"><md-icon>close</md-icon></md-button>
      </template>

      <template v-slot:body>
        <list-client  :data_id="$refs.modalList.data"/>
      </template>

      <!-- <template v-slot:footer>
        <md-card-actions>
          <md-button @click="modalCloseList">
            Close
          </md-button>
        </md-card-actions>
      </template> -->
    </modal>
  </div>
</template>
<script>
import { Modal } from "@/components";
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import {extend} from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';

import ListClient from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/modal/ListClient.vue";

extend('phone', {
  ...required,
  message: 'Phone is required'
  });
  extend('clientname', {
  ...required,
  message: 'Client Name is required'
  });

export default {
  name: "service-card",
  // props: {
  //   s: null,
  // },

  props: ['service_estimate'],

  components: { ValidationError,Modal,"list-client": ListClient
 },

  mixins: [formMixin],

  // data: function () {
  //       return {
  //           client: this.service_estimate.service_estimate_client,
  //           shouldDisable: false
  //       }
  //   },

   data: () => ({
    //  client: [{id:null,client_phone:null,client_name:null,client_email:null,client_address:null}],
     client: [],
      shouldDisable: true
    }),
  methods: {
    async changePhone(){
      this.shouldDisable = true
      let asas = JSON.parse('[{"detail":"","source":{"pointer":"/data/attributes/client_phone"}}]')
      this.setApiValidation(asas)
    },
    async findClient(val){

      this.$refs.modalList.openModal()



      //console.log("asd");
      //console.log(val);

      // if (val && val.length >= 10 ) {
      //   await this.$store.dispatch("workshop_client_master/find_phone", val)
      //   let result = await this.$store.getters["workshop_client_master/client_master"]
      //   console.log(result)
      //   if(result){
      //     this.client = result
      //     let asas = JSON.parse('[{"source":{"pointer":"/data/attributes/client_phones"}}]')
      //     this.setApiValidation(asas)
      //     this.shouldDisable = true
      //   }
      //   else{
      //     this.client = {id:null,client_phone:null,client_name:null,client_email:null,client_address:null}
      //     this.client.client_phone =val
      //     let asas = JSON.parse('[{"detail":"Client not found.","source":{"pointer":"/data/attributes/client_phone"}}]')
      //     this.setApiValidation(asas)
      //     this.shouldDisable = false

      //   }

      // }
    },
    //fungsi yang dipanggil dari sisi parent untuk mendapatkan data di child ini
    getData() {
        this.$emit('data', this.client)
       
    },
    //fungsi untuk mendapatkan data dari parent, digunakan pada saat edit
    getDataParent() {
      
       console.log (this.service_estimate)
       if(this.service_estimate.service_estimate_client !=null){
       this.client= this.service_estimate.service_estimate_client
       this.shouldDisable = true

       }
    },
    //fungsi yang di panggil dari sisi parent untuk mengecheck validasi form di child ini
    async validateForm() {
      const client_phone = this.$refs['client_phone'];
      const client_name = this.$refs['client_name'];
    let result = []
      result.push(
          await client_phone.validate().then(function(data){
          return data.valid
          })
      ) 
      result.push(
        await client_name.validate().then(function(data){
          return data.valid
        })
      )
      
      return result.every(Boolean)
    },
    //fungsi untuk menutup modal list client
    modalCloseList(data){
      console.log(data)
      if(data.id){
        
      this.client = data
      }
      this.$refs.modalList.closeModal()
    },

    CloseListClient(){
      this.$refs.modalList.closeModal();
    },
  },
  
};
</script>

<style lang="scss" scoped>
.md-layout-item{
  margin-top:10px;
}

.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
